/**
 * Конфигурация, приходящая в рантайме.
 *
 * Файл `/config.js` отдаётся вместе со статикой и загружается до бандла.
 * В контейнере его генерирует entrypoint из переменных окружения — так адреса
 * меняются перезапуском контейнера, без пересборки образа.
 *
 * Локально `public/config.js` пустой: значения берутся из `src/config/api.ts`.
 */

export interface RuntimeConfig {
  AUTH_API_BASE_URL?: string;
  ADMIN_API_BASE_URL?: string;
  USERS_API_BASE_URL?: string;
  REALTIME_URL?: string;
}

declare global {
  interface Window {
    __UNIT1_CONFIG__?: RuntimeConfig;
  }
}

export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') return {};
  return window.__UNIT1_CONFIG__ ?? {};
}

/** Значение из рантайм-конфига; пустая строка считается «не задано». */
export function readRuntimeValue(key: keyof RuntimeConfig): string | undefined {
  const value = getRuntimeConfig()[key]?.trim();
  return value ? value : undefined;
}
